import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Dialog, InputBase } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { X } from "lucide-react";
import { createActivity } from "../../api/adminApi";

const AddActivityNoteModal = ({ open, setOpen, orgId, onCreated }) => {
  const [summary, setSummary] = useState("");
  const [body, setBody] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setSummary("");
    setBody("");
    setError(null);
    setLoader(false);
  }, [open]);

  const submit = async () => {
    setError(null);
    if (!summary.trim()) {
      setError("Heading is required");
      return;
    }
    setLoader(true);
    try {
      await createActivity({
        orgId,
        action: "note",
        category: "note",
        summary: summary.trim(),
        body: body.trim() || undefined,
      });
      setOpen(false);
      if (onCreated) onCreated();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.msg ||
          err?.message ||
          "Failed to save note"
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      BackdropProps={{ style: { backgroundColor: "rgb(144,150,160,0.8)" } }}
    >
      <div className="px-8 py-6">
        <div className="relative mb-3">
          <div className="lg:text-[20px] text-[18px] font-semibold">Add note</div>
          <div className="absolute top-0 right-0">
            <X
              className="w-[20px] text-gray-400 cursor-pointer"
              onClick={() => setOpen(false)}
            />
          </div>
        </div>
        {error && (
          <div className="text-red-500 text-[13px] font-semibold mb-2">
            <ErrorOutline sx={{ fontSize: 16 }} /> {error}
          </div>
        )}
        <div className="space-y-3">
          <InputBase
            placeholder="Heading"
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            sx={{
              bgcolor: "white",
              border: "1px solid #E0E0E0",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: "14px",
              borderRadius: "8px",
            }}
          />
          <InputBase
            placeholder="Body (optional)"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            multiline
            minRows={4}
            sx={{
              bgcolor: "white",
              border: "1px solid #E0E0E0",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: "14px",
              borderRadius: "8px",
            }}
          />
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <Button
            onClick={() => setOpen(false)}
            sx={{ textTransform: "none", color: "#6B7280" }}
          >
            Cancel
          </Button>
          <Button
            onClick={submit}
            disabled={loader}
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              borderRadius: "8px",
              px: 2.5,
              "&:hover": { bgcolor: "#4F46E5" },
            }}
          >
            {loader ? <CircularProgress size={18} sx={{ color: "white" }} /> : "Save note"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AddActivityNoteModal;
